import { Directive } from '@angular/core';

import { MasterdataChangeType, WhitelabelImage, WhitelabelImageType } from '../../models';

@Directive()
export class UserEditSuccessPageBaseComponent {
  public whitelabelImage = WhitelabelImage;
  public whitelabelImageType = WhitelabelImageType;
  protected readonly MasterdataChangeType = MasterdataChangeType;
}
